<h2 class="page-title">Page Classification</h2>

<div class="card-section">
  <label class="form-label">
    No-hit phrase
    <span class="text-muted small ms-1">Text that appears on a "no results" page. If the search term appears in the middle of the message, replace it with {{ '{term}' }}.</span>
  </label>
  <input type="text" class="form-control"
    [(ngModel)]="this.data.supplier_implementation.page_type_classification.no_hit_phrase"
    placeholder="your search term {term} resulted in 0 results">
</div>

<div class="card-section">
  <div class="d-flex align-items-center gap-3">
    <button (click)="do_classification_training()" class="btn btn-primary">Train Classifier</button>
    <span class="status-text">{{ status_message }}</span>
  </div>
</div>

<div class="card-section">
  <h5 class="mb-2">Results</h5>
  <p class="mb-0">
    Method of classification:
    <strong>{{ this.data.supplier_implementation.page_type_classification.method_of_page_type_classification }}</strong>
  </p>
  <div class="alert alert-warning mt-3" *ngIf="this.data.supplier_implementation.page_type_classification.no_hit_phrase_recommended">
    No-hit pages couldn't be reliably identified. Add a no-hit phrase above and retrain.
  </div>
</div>
